export var getLabelColor = function getLabelColor(_ref) {
  var disabled = _ref.disabled,
    invert = _ref.invert;
  if (disabled) {
    return invert ? 'disabled-fake-invert' : 'disabled';
  }
  return invert ? 'primary-fake-invert' : 'primary';
};